import { render, staticRenderFns } from "./QuestIcon.vue?vue&type=template&id=4c5416a5&"
import script from "./QuestIcon.vue?vue&type=script&lang=js&"
export * from "./QuestIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports